import { Box, Container, Typography, Grid } from '@mui/material';
import { motion } from 'framer-motion';

export default function BrandMessage() {
  return (
    <Box
      className="circuit-bg"
      sx={{
        py: { xs: 7, md: 10 },
        position: 'relative',
        backgroundColor: '#ffffff',
        overflowX: 'hidden',
        boxSizing: 'border-box',
        borderTop: '1px solid rgba(0,0,0,0.05)',
        '&::after': {
          content: '""',
          position: 'absolute',
          top: 0,
          right: 0,
          bottom: 0,
          width: { xs: 10, md: 16 },
          backgroundImage:
            'repeating-linear-gradient(to bottom, #ff6a00 0 12px, transparent 12px 20px)',
          pointerEvents: 'none',
        },
      }}
    >
      <Container maxWidth="lg" sx={{ px: { xs: 2, sm: 3 } }}>
        <Box
          component={motion.div}
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
        >
          <Typography variant="h3" sx={{ mb: 3, lineHeight: 1.15, color: '#1a1a1a', fontWeight: 800, fontSize: { xs: '1.65rem', sm: '2rem', md: '3rem' } }}>
            Most racking systems are fabricated. Ours are engineered.
          </Typography>
          <Grid container spacing={{ xs: 3, md: 5 }}>
            <Grid item xs={12} md={8}>
              <Typography sx={{ color: '#555', fontSize: '1.05rem', lineHeight: 1.8, mb: 2 }}>
                With a strong foundation in roll forming and section development, we create smarter steel
                profiles that deliver better safety and performance.
              </Typography>
              <Typography sx={{ color: '#555', fontSize: '1.05rem', lineHeight: 1.8 }}>
                That means stronger systems, efficient designs, and storage you can trust.
              </Typography>
            </Grid>
          </Grid>
        </Box>
      </Container>
    </Box>
  );
}
